import "./about.css";

import {get_device} from "../../commonjs/device.js";
import {google} from "../../commonjs/google.js";
import {get_scrollY} from "../../commonjs/scroll.js";
import {IE_scroll} from "../../commonjs/IE_scroll.js";

window.onload = ()=>{
    google();
            const fade_other = document.getElementById(`fade_other`);
            const other_link = document.getElementById(`other_link`);
            const close_nav = document.getElementById(`close_nav`);
            const port_folio = document.getElementById(`port_folio`);
            const contact = document.getElementById(`contact`);
            
            IE_scroll();//IEbackground対策
            
            window.addEventListener(`scroll`,()=>{console.log(get_scrollY());},false);
            
            
            function nav_disappear(){
                other_link.animate([{bottom:`-50px`},{bottom:`0px`}],{
                  duration:1000,
                    easing:`ease-out`,
                    fill:`forwards`
                });
            }
            
            close_nav.addEventListener(`click`,others,false);
            close_nav.addEventListener(`touchstart`,others,false);
            fade_other.addEventListener(`click`,nav_disappear,false);
           fade_other.addEventListener(`touchstart`,nav_disappear,false);
            
            
            
            function others(){
                other_link.animate([{bottom:`0px`},{bottom:`-50px`}],{
                   duration:1000,
                    easing:`ease-out`,
                    fill:`forwards`
                });
            }
          
                
                const Fade_in = function(elm,color){
                    this.elm = elm;
                    this.color = color;
                    const rect = this.elm.getBoundingClientRect();
                    this.scroll = (rect.top+window.pageXOffset)-800;
                    window.addEventListener(`touchmove`,this,false);
                    window.addEventListener(`scroll`,this,false);
                }
                
                Fade_in.prototype.handleEvent = function(){
                    this.window_scrollY = get_scrollY();
                    if(get_device()===`PC`){
                        return;
                    }
                    const set_color = document.defaultView.getComputedStyle(this.elm,null).backgroundColor;
                    const set_text_color = document.defaultView.getComputedStyle(this.elm,null).color;
                    if(this.window_scrollY>this.scroll){
                        this.elm.animate([{backgroundColor:set_color,color:set_text_color},{backgroundColor:this.color,color:`black`}],{
                            duration:3000,
                            fill:`forwards`
                        });
                    }
                }
                
                const _port_folio = new Fade_in(port_folio,`rgba(250, 218, 146, 0.9)`);
                const _contack_link = new Fade_in(contact,`rgba(250, 248, 186, 0.9)`);
                
            
            
            
                const Head_slide = function(elm,scroll_1,scroll_2,begin,end){
                    this.elm = elm;
                    this.begin = begin;
                    this.end = end;
                    this.scroll_1 = scroll_1;
                    this.scroll_2 = scroll_2;
                    
                    window.addEventListener('scroll',this,false);
                    window.addEventListener(`touchmove`,this,false);
                    
                }
                
                Head_slide.prototype.handleEvent = function(){
                    this.window_scrollY = get_scrollY();
                    const trans = document.defaultView.getComputedStyle(this.elm,null).opacity;
                    if(this.window_scrollY>this.scroll_1){
                        this.elm.animate([{opacity:trans},{opacity:this.end}],{
                            duration:300,
                            fill:'forwards'
                        });
                    }
                    if(this.window_scrollY<this.scroll_2){
                        this.elm.animate([{opacity:trans},{opacity:this.begin}],{
                            duration:300,
                            fill:'forwards'    
                        });
                    }
                }
                
                
                const head = new Head_slide(document.getElementById('head_back'),550,540,1,0);
                const back_profile = new Head_slide(document.getElementById(`backpaper`),650,630,0,1);
        }